// extracted by mini-css-extract-plugin
export default {"img":"I63_wr0wErOwiquibX0p"};